
<template>
    <div class="qg-service">
        <van-nav-bar title="联系客服" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <p class="service-title">{{markedWords}}</p>
        <p class="subtitle">客服电话</p>
        <div class="service-box">
          <div class="service-flex" v-for="(item,index) in serviceList" :key="index"  @click="callThisnum(item.phone)">
              <p>{{item.phone}}</p>
              <img class="service-img" src="@/assets/images/telephone-active.png" background-size="cover" />
          </div>
        </div>
        <p class="subtitle">客服工作时间</p>
        <div class="service-box">
          <div class="service-flex">
              <p>周一至周五：</p>
              <div style="flex:1;">8:30-12:00 &nbsp;&nbsp;&nbsp;13:30-18:00</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            markedWords:'尊敬的家长您好，在产品使用过程中，如有任何疑问或者反馈建议，请联系下方客服电话进行沟通处理；',//提示语
            serviceList:[ //电话列表
                {
                    phone:'0752 3278866',
                },
                {
                    phone:'400-9977935',
                }
            ]
        };
    },
    created() {
    },
    methods: {
        /**
         * 拨打电话
         */
        callThisnum(val){
            window.location.href = "tel:"+val;
        },
        /**
         * 返回上一级
         */
        backPage() {
            this.$router.back(-1);
        },
    }
};
</script>

<style lang="scss" scoped>
.qg-service{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 40px 0;
}
.margin-btm{
  padding-bottom: 400px;
}
.service-title{
  margin-top: 60px;
  font-size: 26px;
  font-weight: 400;
  color: #666666;
}
.subtitle{
    width: 100%;
    text-align: left;
    font-size: 26px;
    font-weight: 400;
    color: #666666;
    margin: 60px 0 0 20px;
}
.service-box{
  margin-top: 20px;
  width: 100%;
  min-height: 120px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 32px;
}
.service-box .service-flex:nth-child(n+2){
    border-top: 1px solid #ccc;
}
.service-flex{
  display: flex;
  align-items: center;
  height: 100px;
  font-size: 26px;
  color: #666666;
  justify-content: space-between;
}
.service-flex>p{
  width: 250px;
  font-size: 26px;
  color: #666666;
}
.service-img{
  width: 64px;
  height: 64px;
  margin: 0 0 0 32px;
}
</style>
<style lang="scss">
</style>